import React, { useEffect, useState } from 'react'
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';

const CarouselGallary = ({ lstImg = [] }) => {

  const [images, setImages] = useState([]);

  useEffect(() => {
    getImage();
  }, []);

  const getImage = () => {
    let lstImage = [];
    lstImg.forEach((item) => {
      lstImage.push({
        src: item.sFileLink,
      });
    });
    setImages(lstImage);
  };

  return (
    <Carousel className="article-gallery" images={images} style={{ margin:"10px auto" }} />
  )
}

export default CarouselGallary

